import { Button, Card, ConfirmModal } from '@/components/Bicester';
import React from 'react';
import ServiceInfo from '../../components/ServiceInfo';
import {
  fetchAddEditLuggage,
  fetchLuggageInfo,
  fetchLuggageReceive,
} from '@/services/site/luggage';
import { defaultLuggageEditInfo, luggageSchema } from '../../Luggage/constants';
import { SERVICE_STATUS_TYPE } from '@/constants';
import { SERVICE_STATUS } from '@/services/constants';
import { Alert } from 'rsuite';
import { useModal } from '@ebay/nice-modal-react';
import { useRequest } from 'ahooks';

const Luggage = () => {
  const modal = useModal(ConfirmModal);

  const { run: receive } = useRequest(fetchLuggageReceive, {
    manual: true,
  });

  return (
    <ServiceInfo
      defaultServiceInfo={defaultLuggageEditInfo}
      serviceSchema={luggageSchema}
      fetchInfo={fetchLuggageInfo}
      fetchEdit={fetchAddEditLuggage}
      getDefaultInfo={(data) => {
        return {
          number: data?.number,
          luggage_code: data?.luggage_code,
          remark: data?.remark,
          luggage_status: data?.luggage_status,
        };
      }}
      getSubmitData={(id, values) => Object.assign({}, values, { id })}
      serviceInfo={({ formik, infoData, isEdit }) => (
        <>
          <Card.Input
            required
            isEdit={isEdit}
            label="寄存件数"
            inputType="number"
            formKey="number"
          />
          <Card.Input required isEdit={isEdit} label="行李牌号" formKey="luggage_code" />
          <Card.Input isEdit={isEdit} label="备注" formKey="remark" inputType="textarea" />
          <Card.Picker
            notEditable
            label="寄存状态"
            formKey="luggage_status"
            pickerData={[
              { label: '寄存', value: 1 },
              { label: '已领取', value: 2 },
            ]}
          />
        </>
      )}
      infoBottomToolbar={({ service_id, infoData, isEdit, onReload }) => (
        <div className="flex justify-end mt-[36px]">
          <Button
            className="w-[238px] py-[6px]"
            disabled={
              isEdit ||
              infoData?.status === SERVICE_STATUS_TYPE.CANCELED ||
              infoData?.luggage_status === 2
            } // 编辑状态或已取消或已领取的服务无法点击
            onClick={() => {
              modal.show({
                contentText: '是否确认领取？',
                submitText: '确定',
                cancelText: '放弃',
                onSubmit: () => {
                  receive(service_id).then((res) => {
                    if (res?.status === SERVICE_STATUS.SUCCESS) {
                      Alert.success('领取成功');
                      onReload();
                    }
                  });
                },
              });
            }}
          >
            领取
          </Button>
        </div>
      )}
    />
  );
};

export default Luggage;
